/*
 * Top level module for Reports page
 */

define([
  "marionette",
  "backbone",
  "highcharts/highcharts",
  "jquery",
  "messaging/messenger",
  "modules/reportSplit/reports/reportsView",
  "modules/reportSplit/reports/reportArea/reportAreaModule",
  "modules/reportSplit/reports/singleReport/reportUtilities",
  "modules/reportSplit/reports/configArea/configAreaModule",
], function (
  Marionette,
  Backbone,
  highcharts,
  $,
  Messenger,
  ReportsView,
  ReportAreaModule,
  ReportUtilities,
  ConfigAreaModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "reportsModule";
      this.isOpen = false;
      this.region = options.region;
      this._setUpVents();
      this.opened = false;
    },
    show: function (currentReport) {
      if (currentReport === undefined) {
        return;
      }
      this.isOpen = true;

      this.layout = new ReportsView.reportsLayout();

      //sub module creation
      if (currentReport.toJSON) {
        currentReport = currentReport.toJSON();
      }

      //close any previous report/config divs

      this.reportDiv = this.addSubModule(new ReportAreaModule({ region: this.layout.reportDiv }));
      this.configDiv = this.addSubModule(
        new ConfigAreaModule({
          region: this.layout.configDiv,
          collection: currentReport.reportArguments,
          report: currentReport,
        }),
      );

      //then we've got to actually show the sub modules
      this.layout.on(
        "show",
        function () {
          this._showSubViews(currentReport);
        },
        this,
      );

      this.showRegion(this.layout, currentReport);
    },
    displayReport: function (currentReport) {
      if (currentReport.toJSON) {
        currentReport = currentReport.toJSON();
      }
      let reportName = currentReport.name;
      if (reportName !== null) {
        reportName = $.t(reportName);
      } else {
        reportName = "";
      }
      if (currentReport.drillDownLevel === 0) {
        this.layout.updateHeader(reportName);
        if (currentReport.useArgumentDefaults) {
          if (currentReport.options.subHeader) {
            let subHeader = $.t(currentReport.options.subHeader);
            subHeader = ReportUtilities.figureOutText(subHeader, true);
            this.layout.updateSubheader(subHeader);
          } else {
            this.layout.updateSubheader("");
          }
        }
      }

      this.opened = true;

      //This reqres is needed if drilldowns are used, so that the reportAreaModule
      //can determine whether to hide reports if a drill down at a higher level is changed.
      //Ex: You have report A, it drills down to report B, it drills down to report C
      //You change the drilldown from report A, so report B is different
      //Report C should be hidden
      //This allows report C to be identified and hidden
      Messenger.reqres.setHandler("currentReports", function () {
        return [currentReport];
      });

      //processes, and, if appropriate, displays the report
      this.configDiv.processReport();

      //now show the drilldowns
      while (currentReport.drillDownReport !== null) {
        const drilldown = currentReport.drillDownReport;
        //Allow multiple drilldowns from a single report
        for (let i = 0; i < drilldown.length; i++) {
          const drilldownReport = drilldown[i];
          //see if this drilldown should be shown
          if (drilldownReport.isVisible !== true) {
            break;
          }
          Messenger.vent.trigger("show:drilldown", drilldownReport);
        }
        currentReport = drilldown[0];
      }
    },
    _showSubViews: function (currentReport) {
      if (!currentReport.reportArguments || !currentReport.reportArguments.length) {
        this.layout.hideConfigurationButton();
        this.layout.hideConfiguration();
      } else {
        this.layout.showConfigurationButton();
        this.layout.showConfiguration();
      }
      // This configArea must be shown or else drill down will break
      this.configDiv.show(currentReport);
      this.reportDiv.show(currentReport);
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "show:report:subheader",
        function (text) {
          this.layout.updateSubheader(text);
        },
        this,
      );

      Messenger.vent.on(
        "resize:charts",
        function () {
          this.layout.resizeCharts();
        },
        this,
      );
    },
  });
});
